module.exports = __webpack_public_path__ + "img/iPhone12ProGold.aa8ea08f.jpg";